import { IOption } from 'src/app/components/shared/form/components/form-select/form-select.model';

export const CONSTS = {
  HARDWARE: $localize`Hardware`,
  NO_HARDWARE: $localize`No Hardware`,
  DROPDOWN_LABEL: $localize`CVIS Iterations for Processing Delay`,
};

export const CVIS_OPTIONS: IOption[] = [
  {
    label: '1',
    value: 1,
  },
  {
    label: '2',
    value: 2,
  },
  {
    label: '3',
    value: 3,
  },
  {
    label: '4',
    value: 4,
  },
];
